exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bdr-tabs .card-body[data-v-6ead040e]{padding:1.25rem 0}", ""]);

// exports
